import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { API_URL } from '../../constants/api';
import { decodeToken, getToken } from '../../utils/TokenUtils';

const UserProfile = () => {
  const token = getToken();
  const [user, setUser] = useState([]);
  const userType = decodeToken(token, 'userType');
  const isEnabled2FA = decodeToken(token, 'isEnabled2FA');

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        // API call to login
        const response = await axios.get(
          `${API_URL}/api/users/profile/${userType}-profile`,
          {
            headers: {
              Authorization: token ? `Bearer ${token}` : '',
            },
          }
        );

        console.log(response.data.company);
        setUser(response.data.user[0]);
      } catch (error) {
        // Handle error (e.g., invalid credentials)
        console.log('erro:', error);
        // setError('Company not found');
      }
    };

    fetchProfile();
  }, [token]);

  return (
    <div className="container mt-5">
      <div className="row">
        {/* Profile Header */}
        <div className="col-md-4 text-center">
          <img
            src={`${API_URL}/${user.image}`}
            alt="Profile"
            className="rounded-circle img-fluid"
            style={{ width: '150px', height: '150px', objectFit: 'cover' }}
          />
          <h3 className="mt-3">{user.name}</h3>
          <p className="text-muted">{user.email}</p>
          {isEnabled2FA && (
            <a href="/register-2fa" className="btn btn-danger">
              Enable 2FA
            </a>
          )}
        </div>

        {/* User Details */}
        <div className="col-md-8">
          <h4 className="mb-3">User Details</h4>
          <ul className="list-group">
            <li className="list-group-item">
              <strong>Name:</strong> {user.name}
            </li>
            <li className="list-group-item">
              <strong>Email:</strong> {user.email}
            </li>
            <li className="list-group-item">
              <strong>Username:</strong> {user.user_name}
            </li>
            {/* <li className="list-group-item">
              <strong>Gender:</strong> {user.gender}
            </li> */}
            <li className="list-group-item">
              <strong>Status:</strong> {user.status}
            </li>
            <li className="list-group-item">
              <strong>Joined:</strong> {user.date}
            </li>
            <li className="list-group-item">
              <strong>Last Activity:</strong> {user.modified_date}
            </li>
            <li className="list-group-item">{token}</li>
          </ul>
        </div>
      </div>

      {/* Additional Information */}
      {/* <div className="row mt-5">
        <div className="col-md-6">
          <h4>Recent Activities</h4>
          <ul className="list-group">
            <li className="list-group-item">Logged in from a new device.</li>
            <li className="list-group-item">Updated profile picture.</li>
            <li className="list-group-item">Changed account password.</li>
          </ul>
        </div>
        <div className="col-md-6">
          <h4>Settings</h4>
          <button className="btn btn-primary w-100 mb-2">Edit Profile</button>
          <button className="btn btn-danger w-100">Logout</button>
        </div>
      </div> */}
    </div>
  );
};

export default UserProfile;
